/** Task analytics kind API calculation mode */
export enum TaskAnalyticsKindEnum {
  /** Compute by direction group */
  BY_DIRECTION_GROUP = 'BY_DIRECTION_GROUP',
  /** Compute by direction */
  BY_DIRECTION = 'BY_DIRECTION',
}
